"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findEditionIdFromHostname = exports.ClientSafeConfig = void 0;
const config_client_1 = __importDefault(require("./config/editions/config.client"));
exports.ClientSafeConfig = config_client_1.default;
const find_edition_id_from_hostname_client_1 = require("./find-edition-id-from-hostname.client");
Object.defineProperty(exports, "findEditionIdFromHostname", { enumerable: true, get: function () { return find_edition_id_from_hostname_client_1.findEditionIdFromHostname; } });
//# sourceMappingURL=client.js.map